import script from "./UiMultiToggle.vue?vue&type=script&setup=true&lang=js"
export * from "./UiMultiToggle.vue?vue&type=script&setup=true&lang=js"

import "./UiMultiToggle.vue?vue&type=style&index=0&id=0efa4c3d&lang=css"

const __exports__ = script;

export default __exports__